import React from "react";
function Tel(props) {
  if (!props.num) return null;
  const areaCode = props.num[0];
  const exchange = props.num[1];
  const line = props.num[2];
  return (
    <a href={`tel:+1${areaCode}${exchange}${line}`}>
      ({areaCode}) {exchange}-{line}
    </a>
  );
}
export default Tel;
